module.exports = __webpack_public_path__ + "static/img/zhongLun.8dd7f57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LunBo/zhongLun.jpg
// module id = SwsC
// module chunks = 0